export default "__VITE_ASSET__CNCyqbwj__"